import type { $Fetch } from 'ofetch';
import type { NfseGateway, CobrancaGatewayGateway } from '@/application/port/out/FaturamentoGateways';
import type {
  NfseEmissao, EmitirNfseCommand, CobrancaGatewayResult, EmitirCobrancaCommand,
} from '@/domain/model/Faturamento';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateways de faturamento por parcela (commerce).
 * NFS-e `/api/v1/commerce/parcelas/{parcelaId}/nfse`; cobrança `.../cobranca-gateway`.
 *
 * @since G.5.20
 */
export class HttpNfseGateway implements NfseGateway {
  private path(parcelaId: string): string {
    return `/api/v1/commerce/parcelas/${encodeURIComponent(parcelaId)}/nfse`;
  }
  constructor(private readonly client: $Fetch) {}

  async emitir(parcelaId: string, cmd: EmitirNfseCommand): Promise<NfseEmissao> {
    const res = await this.client<ApiResponse<NfseEmissao>>(this.path(parcelaId), { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
  async consultar(parcelaId: string): Promise<NfseEmissao> {
    const res = await this.client<ApiResponse<NfseEmissao>>(this.path(parcelaId), { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}

export class HttpCobrancaGatewayGateway implements CobrancaGatewayGateway {
  constructor(private readonly client: $Fetch) {}

  async emitir(parcelaId: string, cmd: EmitirCobrancaCommand): Promise<CobrancaGatewayResult> {
    const res = await this.client<ApiResponse<CobrancaGatewayResult>>(
      `/api/v1/commerce/parcelas/${encodeURIComponent(parcelaId)}/cobranca-gateway`,
      { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
